import { Box, Button, CardContent, TextField, Grid, Typography, CircularProgress } from "@mui/material"
import { useState } from "react"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import PaperComponent from "../paper-component"
import { Help } from "@mui/icons-material"
import { ProgressWrapper } from "components/common-styles"

const ImportConfirmDialog = ({ open, title, isDiscard, onClose, onConfirm }) => {
  const [isValid, setIsValid] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return

    onClose()
  }

  const handleConfirm = async () => {
    if (!isValid && !isDiscard) return

    if (onConfirm) {
      setLoading(true)
      await onConfirm()
      setLoading(false)
    }

    onClose()
  }

  const onTextChanged = event => {
    setIsValid(event.target.value.toUpperCase() === "IMP")
  }

  const onKeyPress = event => {
    if (event.key === "Enter") {
      handleConfirm()
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title">
      <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
        {`${isDiscard ? "Discard" : "Import"} ${title}`}
      </DialogTitle>
      <DialogContent dividers>
        <CardContent style={{ minWidth: 300 }}>
          {loading ? (
            <ProgressWrapper>
              <CircularProgress size={64} />
            </ProgressWrapper>
          ) : (
            <Grid container spacing={3} style={{ textAlign: "center" }}>
              <Grid item md={12} xs={12}>
                <Help color="primary" fontSize="large" sx={{ width: "2em", height: "2em" }} />
              </Grid>
              <Grid item md={12} xs={12}>
                {isDiscard ? (
                  <Typography color="textPrimary" gutterBottom variant="h5">
                    Are you sure you wanted to <br /> Discard this file?
                  </Typography>
                ) : (
                  <Box>
                    Please type <b>IMP</b> in the textbox confirm
                  </Box>
                )}
              </Grid>

              {!isDiscard && (
                <Grid item md={12} xs={12}>
                  <TextField
                    autoFocus={true}
                    placeholder="_ _ _"
                    onChange={onTextChanged}
                    onKeyPress={onKeyPress}
                    InputProps={{
                      style: { width: 100 },
                      inputProps: {
                        style: { textAlign: "center", textTransform: "uppercase" },
                        maxLength: 3,
                      },
                    }}
                  />
                </Grid>
              )}
            </Grid>
          )}
        </CardContent>
      </DialogContent>
      {!loading && (
        <DialogActions>
          <Button onClick={onClose} color="info" variant="outlined">
            Cancel
          </Button>
          <Button onClick={handleConfirm} disabled={!isValid && !isDiscard} variant="contained">
            {`${isDiscard ? "Discard" : "Confirm"}`}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  )
}

export default ImportConfirmDialog
